import { render, staticRenderFns } from "./DialogNormal.vue?vue&type=template&id=0b104391&scoped=true&"
import script from "./DialogNormal.vue?vue&type=script&lang=js&"
export * from "./DialogNormal.vue?vue&type=script&lang=js&"
import style0 from "./DialogNormal.vue?vue&type=style&index=0&id=0b104391&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b104391",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardActions,VCardText,VDialog,VRow})
